<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="Reporting">
    <div
      v-if="
        getCurrentUser.clientType === USER_TYPE.B2B2B &&
          (getCurrentUser.admin ||
            (getCurrentUser.role &&
              getCurrentUser.role.roleType === ROLE_TYPE.ADMIN_AGENCE))
      "
      class="giga-actions giga-actions_full giga-actions_start"
    >
      <ul class="giga-actions_row">
        <filter-modal
          :query-config="queryConfig"
          v-on:onFilter="onFilter($event)"
          v-on:onReloadData="onFilter($event)"
          :headerTitle="'filtrer_document'"
        ></filter-modal>
      </ul>
    </div>

    <page-loader v-if="reportingLoader.fiche"></page-loader>

    <div v-if="!reportingLoader.volume || !reportingLoader.fiche">
      <div class="giga-card">
        <div class="giga-card_wrap">
          <div class="giga-card_header">
            <h3 class="giga-card_title">{{ $t("report_volume") }}</h3>
            <div class="giga-button">
              <button @click="exportChart" class="with-icon giga-green_button">
                <i class="giga-icon">
                  <b-spinner
                    v-if="downloadingChart"
                    variant="light"
                    small
                    class="spinner"
                  ></b-spinner>
                </i>
                <i class="giga-icon" v-if="!downloadingChart">
                  <svg
                    class="stroke"
                    width="20"
                    height="17"
                    viewBox="0 0 20 17"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.2386 10.7527V14.0036C18.2386 14.8999 17.3821 15.6267 16.3258 15.6267H2.91284C1.85648 15.6267 0.999969 14.8999 0.999969 14.0036V10.7527"
                      stroke="white"
                      stroke-width="1.69271"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M4.83139 6.68774L9.61642 10.7526L14.4072 6.68774"
                      stroke="white"
                      stroke-width="1.69271"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M9.61639 10.7528V1"
                      stroke="white"
                      stroke-width="1.69271"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </i>
                <span>{{ $t("download") }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="giga-widget_body">
              <template>
                <div class="giga-volume_filter">
                  <ul class="giga-volume_filter_list">
                    <li
                      v-for="month in periods"
                      :key="month"
                      class="giga-volume_filter_item"
                      @click="reloadChart(month)"
                    >
                      <input
                        type="radio"
                        :value="month"
                        name="filterInterval"
                        v-model="period"
                      />
                      <label
                        v-if="reportingLoader.volume && period === month"
                        class="giga-icon"
                      >
                        <b-spinner
                          variant="dark"
                          small
                          class="spinner"
                        ></b-spinner>
                      </label>
                      <label
                        :class="{ active: month === period }"
                        v-else
                        for=""
                        >{{ getPeriod(month) }}</label
                      >
                    </li>
                  </ul>
                </div>
                <reporting-widget
                  ref="volumeChart"
                  :labels="volumeData.labels"
                  :values="volumeValues"
                ></reporting-widget>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- FICHE -->
      <div v-if="!reportingLoader.fiche" class="giga-card giga-margin-t_65">
        <div class="giga-card_wrap">
          <div class="giga-card_header">
            <h3 class="giga-card_title">{{ $t("fiches") }}</h3>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <div class="giga-file_box">
                <div class="giga-file_box_icon">
                  <i class="mostused-icon"
                    ><img src="@/assets/images/icons/mostUsed.svg"
                  /></i>
                </div>
                <div class="giga-file_box_content">
                  <h4 class="file-box_title">{{ $t("fiche_most_filed") }}</h4>
                  <p class="file-box_value">{{ ficheData.mostUsed }}</p>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="giga-file_box">
                <div class="giga-file_box_icon">
                  <i class="mostused-icon"
                    ><img src="@/assets/images/icons/mostUsed.svg"
                  /></i>
                </div>
                <div class="giga-file_box_content">
                  <h4 class="file-box_title">
                    {{ $t("fiche_with_highest_volume") }}
                  </h4>
                  <p class="file-box_value">{{ ficheData.biggestVolume }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- BREAKING RATE -->
      <div class="giga-card giga-margin-t_65">
        <div class="giga-card_wrap">
          <div class="giga-card_header">
            <h3 class="giga-card_title">{{ $t("breakage_rate") }}</h3>
          </div>
        </div>
        <operation-widget></operation-widget>
      </div>
    </div>
  </div>
</template>

<script>
// import VolumeChart from '@/views/Reporting/VolumeChart';
import { ReportingService } from "@/views/Reporting/services";
import Exporter from "vue-chartjs-exporter";
import reportingWidget from "./widgets/reportingWidget.vue";
import pageLoader from "../../components/static/pageLoader";
import PageLoader from "../../components/static/pageLoader.vue";
import OperationWidget from "../Dashboard/widgets/OperationWidget";
import { mapGetters } from "vuex";
import { constants } from "@/shared/constants";
import { agenceService } from "@/views/service/agence.service";
import FilterModal from "@/components/static/FilterModal.vue";

const Moment = require("moment");
const MomentRange = require("moment-range");
const moment = MomentRange.extendMoment(Moment);

export default {
  name: "Reporting",
  components: {
    FilterModal,
    OperationWidget,
    reportingWidget,
    pageLoader,
    PageLoader
  },
  data() {
    return {
      gradientValue: "",
      volumeValues: null,
      volumeData: [],
      downloadingChart: false,
      ficheData: {
        mostUsed: null,
        biggestVolume: null
      },
      reportingLoader: {
        volume: false,
        fiche: false
      },
      periods: [1, 3, 6, 9, 12, 24, 36],
      period: 1,
      USER_TYPE: constants.USER_TYPE,
      ROLE_TYPE: constants.ROLE_TYPE,
      agence: null,
      agences: [],
      queryConfig: {
        fields: []
      }
    };
  },
  mounted() {
    (this.period = this.periods[0]), (this.reportingLoader.volume = true);
    this.reportingLoader.fiche = true;
    this.fetchAgencesAndFiche();
    this.fetchAgences();
  },
  computed: {
    ...mapGetters("account", ["getCurrentUser"])
  },
  methods: {
    reloadChart(month) {
      this.period = month;

      this.reportingLoader.volume = true;
      ReportingService.getClientVolumeData(month)
        .then(data => {
          this.setChartData(data);
        })
        .finally(() => (this.reportingLoader.volume = false));
    },
    getPeriod(month) {
      return month < 12 ? `${month}M` : `${month / 12}An`;
    },
    setChartData(data) {
      if (data.length > 0) {
        const start = moment.utc(
            `${data[data.length - 1].year}-${
              data[data.length - 1].month
            }-1 00:00:00.000`
          ),
          end = moment();
        const range = moment.range(moment(start), moment(end));
        const dateRange = Array.from(range.by("month", { step: this.period }));
        const labels = dateRange.map(date => date.format("MM/YYYY"));
        const chartData = [];
        dateRange.forEach(date => {
          const value = data.filter(
            elm => elm.year === date.year() && elm.month === date.month() + 1
          );
          if (value.length > 0) {
            chartData.push(value[0].count);
          } else {
            chartData.push(0);
          }
        });
        (this.volumeValues = chartData),
          (this.volumeData = {
            labels: labels,
            datasets: [
              {
                data: chartData,
                // backgroundColor: this.gradientValue,
                // borderColor: "rgba(108, 190, 62, 0.50)",
                // pointBackgroundColor: "rgba(108, 190, 62, 1)",
                fill: false,
                pointRadius: 4,
                pointBackgroundColor: this.gradientValue,
                borderWidth: 2,
                borderColor: "#79B145",
                lineTension: 0
              }
            ]
          });
      } else {
        this.volumeData = [];
        this.volumeValues = null;
      }
    },
    setGradientStyle(value) {
      console.log(value);
    },
    exportChart() {
      if (
        this.$refs.volumeChart.$data &&
        this.$refs.volumeChart.$data._chart &&
        this.$refs.volumeChart.$data._chart.canvas
      ) {
        this.downloadingChart = true;
        this.exportCsv();
      }
    },
    setFicheData(data) {
      this.ficheData.mostUsed = data.mostUsedFiche;
      this.ficheData.biggestVolume = data.ficheWithBiggestVolume;
    },
    exportCsv() {
      const reportingVolumeDto = [];
      const chart = this.$refs.volumeChart.$data._chart;
      const labels = chart.data.labels;
      const datasets = chart.data.datasets;
      labels.forEach((label, i) => {
        reportingVolumeDto.push({ temps: label, volume: datasets[0].data[i] });
      });

      ReportingService.downloadOperationVolumeByMonth(reportingVolumeDto)
        .then(result => {
          const blob = new Blob([result], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "volume-operation.xlsx";
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .finally(() => (this.downloadingChart = false));
    },
    fetchAgences() {
      agenceService.allUserAgencesList().then(res => {
        this.agences = res.content;
        const field = {
          element: "agence",
          name: "Agence",
          type: "select",
          options: res,
          entity: "enum",
          custom: false,
          isUserAgence: true
        };
        this.queryConfig.fields.push(field);
      });
    },
    fetchAgencesAndFiche() {
      const agenceId = this.agence ? this.agence.id : null;
      ReportingService.getClientVolumeData(this.period, agenceId)
        .then(data => {
          this.setChartData(data);
        })
        .finally(() => (this.reportingLoader.volume = false));
      ReportingService.getFicheData()
        .then(data => this.setFicheData(data))
        .finally(() => (this.reportingLoader.fiche = false));
    },
    onFilter(event) {
      if (event.filters && event.filters[0]?.value) {
        this.agence = event.filters[0].value.value;
      } else {
        this.agence = null;
      }
      this.fetchAgencesAndFiche();
    }
  }
};
</script>

<style scoped>
.th-p,
.td-p {
  padding: 1rem !important;
}
</style>
